import { redirect, RouteObject } from 'react-router';

import { BusinessCategoryDetails } from './CategoryDetails';
import { BusinessCategoryList } from './CategoryList';
import { CustomDrinkDetails } from './CustomDrinkDetails';
import { CustomDrinkList } from './CustomDrinkList';
import { BusinessDefaultProductDetails } from './DefaultProductDetails';
import { BusinessDefaultProductList } from './DefaultProductList';
import { MenuItemDetails } from './MenuItemDetails';
import { MenuItemList } from './MenuItemList';
import { PourAvailabilityDetails } from './PourAvailabilityDetails';
import { PourAvailabilityList } from './PourAvailabilityList';
import { BusinessPriceTierDetails } from './PriceTierDetails';
import { BusinessPriceTierList } from './PriceTierList';
import { BusinessProductPriceTierDetails } from './ProductPriceTierDetails';
import { BusinessProductPriceTierList } from './ProductPriceTIerList';
import { ServingContainerDetails } from './ServingContainerDetails';
import { BusinessServingContainerList } from './ServingContainerList';

export const BUSINESS_MENU_ROUTES: RouteObject[] = [
    {
        index: true,
        loader: () => redirect('/business-menu/menu-items'),
    },
    { path: 'categories', Component: BusinessCategoryList },
    { path: 'categories/:id', Component: BusinessCategoryDetails },
    { path: 'custom-drinks', Component: CustomDrinkList },
    { path: 'custom-drinks/:id', Component: CustomDrinkDetails },
    { path: 'default-products', Component: BusinessDefaultProductList },
    { path: 'default-products/:id', Component: BusinessDefaultProductDetails },
    { path: 'menu-items', Component: MenuItemList },
    { path: 'menu-items/:id', Component: MenuItemDetails },
    { path: 'pour-availability', Component: PourAvailabilityList },
    { path: 'pour-availability/:id', Component: PourAvailabilityDetails },
    { path: 'price-tiers', Component: BusinessPriceTierList },
    { path: 'price-tiers/:id', Component: BusinessPriceTierDetails },
    { path: 'product-price-tiers', Component: BusinessProductPriceTierList },
    {
        path: 'product-price-tiers/:id',
        Component: BusinessProductPriceTierDetails,
    },
    { path: 'serving-containers', Component: BusinessServingContainerList },
    { path: 'serving-containers/:id', Component: ServingContainerDetails },
];
